<div class="user-route-display leading-tight">
  <!-- Detailed format -->
  <div *ngIf="displayMode === 'detailed'" class="table-text-m">
    <!-- Ruta -->
    <div
      *ngIf="showRoute && (routeCodeValue || routeNameValue)"
      class="flex items-center gap-x-1"
    >
      <div class="flex flex-col">
         <div class="flex items-center">
           <strong>Ruta:</strong>
           
        <span *ngIf="routeCodeValue" class="code-text">
          {{ routeCodeValue }}
          <!-- Route Navigation -->
          <app-sub-route-navigation
            *ngIf="isRouteNavigable"
            [route]="routeNavigationData"
            [displayMode]="'code'"
            [openInNewTab]="openNavigationInNewTab"
            [showIcon]="true"
            [showText]="false"
            [interactionMode]="navigationInteractionMode"
            [customClass]="'table-text-code'"
            (routeNavigate)="handleRouteNavigation($event)"
          >
          </app-sub-route-navigation>
        </span>
         </div>
        <span>{{ routeNameValue }}</span>
      </div>
    </div>

    <!-- Usuario -->
    <div *ngIf="showUser && userValue" class="flex items-center gap-x-2">
      <strong>Usuario:</strong>
      <span>{{ userValue }}</span>

      <mat-icon
        *ngIf="showUserIcon"
        class="cursor-pointer"
        matTooltip="{{ userIconTooltip }}"
        (click)="handleUserIconClick()"
        (mouseenter)="isUserIconHovered = true"
        (mouseleave)="isUserIconHovered = false"
      >
        {{ isUserIconHovered ? userIconHover : userIconDefault }}
      </mat-icon>
    </div>

    <!-- Responsable -->
    <div
      *ngIf="showResponsible && (responsibleCodeValue || responsibleValue)"
      class=""
    >
      <div class="flex items-center gap-x-1">
        <div class="flex flex-col">
         <div class="flex items-center">
           <strong>Respons. :</strong>
          <span *ngIf="responsibleCodeValue" class="code-text ml-1">
            {{ responsibleCodeValue }}
            <!-- Business Partner Navigation -->
            <app-business-partner-navigation
              *ngIf="isResponsibleNavigable"
              [businessPartner]="responsibleNavigationData"
              [displayMode]="'code'"
              [openInNewTab]="openNavigationInNewTab"
              [showIcon]="true"
              [showText]="false"
              [interactionMode]="navigationInteractionMode"
              [customClass]="'table-text-code'"
              (businessPartnerNavigate)="handleResponsibleNavigation($event)"
            >
            </app-business-partner-navigation>
          </span>
         </div>
          <span *ngIf="responsibleValue">{{ responsibleValue }}</span>
        </div>
      </div>
    </div>
  </div>

  <!-- Simple formats -->
  <div *ngIf="displayMode !== 'detailed'" class="flex items-center gap-x-1">
    <span class="font-descrip">
      <span *ngIf="showRouteCode && routeCodeValue" class="code-text uppercase">
        {{ routeCodeValue }}
      </span>
      <span *ngIf="showRouteCode && routeCodeValue"><br /></span>
      {{ displayText }}
    </span>
    <!-- Route Navigation (only if route is shown) -->
    <app-sub-route-navigation
      *ngIf="showRoute && isRouteNavigable"
      [route]="routeNavigationData"
      [displayMode]="'code'"
      [openInNewTab]="openNavigationInNewTab"
      [showIcon]="true"
      [showText]="false"
      [interactionMode]="navigationInteractionMode"
      [customClass]="'table-text-code'"
      (routeNavigate)="handleRouteNavigation($event)"
    >
    </app-sub-route-navigation>
    <!-- Business Partner Navigation (only if responsible is shown) -->
    <app-business-partner-navigation
      *ngIf="showResponsible && isResponsibleNavigable"
      [businessPartner]="responsibleNavigationData"
      [displayMode]="'code'"
      [openInNewTab]="openNavigationInNewTab"
      [showIcon]="true"
      [showText]="false"
      [interactionMode]="navigationInteractionMode"
      [customClass]="'table-text-code'"
      (businessPartnerNavigate)="handleResponsibleNavigation($event)"
    >
    </app-business-partner-navigation>
  </div>
</div>
